import classnames from 'classnames';
import type { FC } from 'react';

import OutlineBundleCheckboxSkel from './components/OutlineBundleCheckbox/OutlineBundleCheckbox.skel';
import OutlineBundleProductCardSkel from './components/OutlineBundleProductCard/OutlinebundleProductCard.skel';
import type { IOutlineBundleProductSkel } from './OutlineBundleProduct.interfaces';

import styles from './outlineBundleProduct.module.scss';

const OutlineBundleProductSkel: FC<IOutlineBundleProductSkel> = ({
  withCheckbox,
}) => (
  <div
    className={classnames(styles.wrapper, {
      [styles.withCheckbox]: withCheckbox,
    })}
  >
    {withCheckbox && <OutlineBundleCheckboxSkel />}
    <div className={styles.productWrapper}>
      <OutlineBundleProductCardSkel />
    </div>
  </div>
);

OutlineBundleProductSkel.displayName = 'OutlineBundleProductSkel';

export default OutlineBundleProductSkel;
